// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorTwoToneSvg from "@ant-design/icons-svg/es/asn/CalculatorTwoTone";
import AntdIcon from '../components/AntdIcon';

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorTwoToneSvg
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
export default React.forwardRef(CalculatorTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CalculatorTwoTone.js
// module id = 705
// module chunks = 0